import type { CreateUserDto } from './createUserDto.interface';

export type UpdateUserDto = Omit<CreateUserDto, 'acceptPolicy' | 'email' | 'organizationName'>;
